import React from 'react'
import { graphql } from 'gatsby'
import { useJsonForm } from 'gatsby-tinacms-json'
import { usePlugin } from 'tinacms'
import { InlineForm, InlineTextarea } from 'react-tinacms-inline'
import { InlineWysiwyg } from 'react-tinacms-editor'

import Layout from '../components/Layout'
import Banner from '../components/Banner'
import SEO from '../components/Seo'

const Contact = ({ data }) => {
    const formConfig = {
        id: 2,
        label: 'Edit Contact Page',
        fields: [
            {
                label: 'SEO Title',
                name: 'rawJson.seo_title',
                component: 'textarea'
            },
            {
                label: 'Meta Description',
                name: 'rawJson.meta_description',
                component: 'textarea'
            }
        ]
    }

    const [modifiedData, form] = useJsonForm(data.page, formConfig)
    usePlugin(form)

    return (
        <Layout>
            <SEO
                title={modifiedData.seoTitle}
                description={modifiedData.metaDescription}
            />
            <InlineForm form={form} >
                <div className="mainContainer">
                    <div className="container-fluid s2">
                        <div className="container">
                            <div className="row">
                                <h1 className="center">
                                    <InlineTextarea name="rawJson.title" />
                                </h1>
                                <div className="container center">
                                    <InlineWysiwyg name="rawJson.contact_info" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.contactInfo,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                    <hr />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <InlineWysiwyg name="rawJson.call" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.call,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                </div>
                                <p>&nbsp;</p>
                                <div className="col-lg-6 col-md-6">
                                    <InlineWysiwyg name="rawJson.email" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.email,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                </div>
                                <div className="row"><a id="find-us"></a>
                                    <div className="col-lg-6 col-md-6">
                                        <InlineWysiwyg name="rawJson.social_media" format="html">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: modifiedData.socialMedia,
                                                }}
                                            />
                                        </InlineWysiwyg>
                                    </div>
                                    <a id="send-us"></a>
                                    <div className="col-lg-6 col-md-6">
                                        <InlineWysiwyg name="rawJson.letter" format="html">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: modifiedData.letter,
                                                }}
                                            />
                                        </InlineWysiwyg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </InlineForm>
            <Banner />
        </Layout>
    )
}

export default Contact

export const pageQuery = graphql`
query {
    page: pagesJson(fileRelativePath: { eq: "/content/pages/contact.json" }) {
        title
        metaDescription: meta_description
        seoTitle: seo_title
        contactInfo: contact_info
        call
        letter
        socialMedia: social_media
        email

        rawJson
        fileRelativePath
    }
}`